import React from 'react';

import { isEmpty, noop } from 'lodash';
import ProtectorContext, { useProtectorContext, ProtectorState } from './context';
import useCheckPermissions from '../use_check_permissions';

type NonEmptyArray<T> = [T, ...T[]];

interface ProtectorProps {
  permissions: NonEmptyArray<string>;
  restaurantId?: string;
  children: React.ReactNode;
}

interface ProtectorChildProps {
  children: React.ReactNode;
}

const Protector = ({ permissions, restaurantId, children }: ProtectorProps) => {
  if (isEmpty(permissions)) {
    throw new Error("โปรดติดต่อ Admin เพื่อแก้ไข (The 'permissions' prop cannot be an empty array.)");
  }

  const { isAllowed } = useCheckPermissions(permissions, { restaurantId });
  const state: ProtectorState = isAllowed ? 'valid' : 'invalid';

  // NOTE: legacy setState on context kept for back-compat; no consumer calls it.
  return <ProtectorContext.Provider value={{ state, setState: noop }}>{children}</ProtectorContext.Provider>;
};

const Allowed = ({ children }: ProtectorChildProps) => {
  const { state } = useProtectorContext();
  return state === 'valid' ? children : null;
};

const Rejected = ({ children }: ProtectorChildProps) => {
  const { state } = useProtectorContext();
  return state === 'invalid' ? children : null;
};

Protector.Allowed = Allowed;
Protector.Rejected = Rejected;

export default Protector;
